import {Card} from "antd";
import FakeTable from "../../components/FakeTable";
import React from "react";

export default ({title, cardProps, emptyMsg, hidenOnEmpty, ...props}) => (props.objs?.length || !hidenOnEmpty) && <Card title={title} className="narrow-card" {...cardProps}>
  { props.objs?.length || !emptyMsg ? <FakeTable {...props} /> : <div className="p-2">{emptyMsg}</div> }
</Card>
